import {
  takeLatest,
  put,
  putResolve,
  select,
} from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionAuthRequest } from '../actions';

import { maybeHandleCriticalErrorWithHistory } from 'react-redux-app/lib/modules/api/utils';

import {
  ACTION_ASK_UNSUSPEND__SUCCESS,
  ACTION_DELETE_NOTIFICATION__SUCCESS,
} from '../actionTypes';

import { getAuthError } from '../selectors';


function* reloadAuth(history) {
  try {
    yield putResolve(actionAuthRequest());

    const error = yield select(getAuthError);
    maybeHandleCriticalErrorWithHistory(history, error?.globalErrors);
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga(history) {
  yield takeLatest([
    ACTION_ASK_UNSUSPEND__SUCCESS,
    ACTION_DELETE_NOTIFICATION__SUCCESS,
  ], reloadAuth, history);
}
